/**
 * What an agency's people see while the platform has suspended it (TZ §2.2).
 *
 * The screen replaces the pages. The owner keeps one way in: the billing page, where a
 * suspension's cost is visible. The gate itself is `showsSuspendedScreen` in lib/support.
 */
import { type JSX } from "react";
import { Link } from "react-router";

import { useAuthStore } from "@/store/auth";

export function SuspendedScreen(): JSX.Element {
  const role = useAuthStore((state) => state.user?.role ?? undefined);

  return (
    <section className="mx-auto flex max-w-md flex-col gap-3 py-16 text-center">
      <h1 className="text-h2 font-semibold text-ink">Agentlik to'xtatilgan</h1>
      <p className="text-sm text-ink-muted">
        Kapitan jamoasi agentlik faoliyatini vaqtincha to'xtatdi. Ma'lumotlar saqlanadi,
        ammo ishlash mumkin emas.
      </p>
      {role === "owner" ? (
        <div>
          <Link to="/sozlamalar/tarif" className="text-sm font-medium text-accent-ink hover:underline">
            Tarif va kreditlar
          </Link>
        </div>
      ) : null}
    </section>
  );
}
